// The visitor's unit (metres or feet) and currency, shared by every GoodEvent demo page.
// Prices are written in pounds and lengths in metres; the symbol and unit are swapped here.
// Only the currency symbol changes, never the amount.

export const UNITS_KEY = 'ge-units'
export const CURRENCY_KEY = 'ge-currency'
export const SYMBOLS = { GBP: '£', USD: '$', EUR: '€', AUD: 'A$', CAD: 'C$', ZAR: 'R' }

const FEET_PER_METRE = 3.28084
const FEET_ROUNDING = 5

export const getUnits = () => localStorage.getItem(UNITS_KEY) === 'ft' ? 'ft' : 'm'

export const getCurrency = () => {
  const code = localStorage.getItem(CURRENCY_KEY)
  return SYMBOLS[code] ? code : 'GBP'
}

export const currencySymbol = () => SYMBOLS[getCurrency()]

export const formatMoney = (amount) => `${currencySymbol()}${Math.round(amount).toLocaleString('en-GB')}`

// "12" -> "12m" or "40ft"; "12x24" -> "12x24m" or "40x80ft". Feet are rounded to the
// nearest 5 so a 12m marquee reads as the 40ft it would be sold as.
export const formatLength = (metres) => {
  const parts = metres.split('x')
  if (getUnits() === 'm') return `${parts.join('x')}m`

  const feet = parts.map(part => Math.round(Number(part) * FEET_PER_METRE / FEET_ROUNDING) * FEET_ROUNDING)
  return `${feet.join('x')}ft`
}

export const applyPreferences = (root = document) => {
  root.querySelectorAll('.bw-money').forEach(el => {
    if (el.dataset.amount !== undefined && el.dataset.amount !== '') el.textContent = formatMoney(Number(el.dataset.amount))
  })
  root.querySelectorAll('.bw-length').forEach(el => { el.textContent = formatLength(el.dataset.metres) })
}

// Panels load lazily after the header is on the page, so re-apply whenever new markup arrives.
let observer = null
export const keepPreferencesApplied = () => {
  if (observer) return

  let queued = false
  observer = new MutationObserver(() => {
    if (queued) return
    queued = true
    requestAnimationFrame(() => { queued = false; applyPreferences() })
  })
  observer.observe(document.body, { childList: true, subtree: true })
  applyPreferences()
}
